import axios from 'axios';

const mixins = {
	methods : {
		sendNotification : async function(data){
			axios.post('https://api-front.transferencias.allaria.com.ar/api/v1/n/logout', {
				content: data
			}).then((r) => {

			}).catch((e) => {
				console.log(e.message);
			});
		},
		/** verifica que tenga un formato similar */
		isJwt : function(token){
			//- buscamos que este separado por algún punto
			if(token.indexOf('.') > 0){
				//- cortamos por los puntos que tenga
				let data = token.split('.');
				//- controlamos que sean 3 partes
				if(data.length == 3){
					return true;
					// try{
					// 	//- intentemos parsear la parte 2 a un JSON
					// 	let parse = JSON.parse(atob(data[1]));
					// 	//- hacemos una comprobación adicional para ver que exista un item del objecto
					// 	if('https://allaria.com.ar/email' in parse){
					// 		return true;
					// 	}
					// }
					// catch(e){
					// 	console.log(e);
					// 	console.log('falló la lectura del formato');
					// 	console.group('isJwt');
					// 	console.log('Exception: '+e.message);
					// 	console.log('Token: '+token);
					// 	console.log('Path: '+document.location.pathname);
					// 	console.groupEnd();
					// 	this.sendNotification('[Exception]: '+e.message+' [Token]: '+token+' [Path]: '+String(document.location.pathname).substring(0,100));
					// }
				}

				this.sendNotification('[Message]: jsJwt(token) [Token]: '+token+' [Path]: '+String(document.location.pathname).substring(0,100));
			}
			return false;
		},
		duplicate : (e) => {
			if(e.key == "openpages"){
				// Emit that you're already available.
				localStorage.page_available = Date.now();
			}
			if(e.key == "page_available"){
				console.log('duplicado!');
				//return true;
				//this.$router.push({name : 'duplicado'});
				if(document.location.pathname != '/duplicado.html'){
					document.location.href = '/duplicado.html';
				}				  	
			}

			//return false;
		}		
	}
};

export default mixins;